import BaseService from "./BaseService";

export default class ThemeServices extends BaseService {
    public static getTenantConfig(postData: any) {
        return BaseService.sendRequest(process.env.REACT_APP_API_URL + 'tenant/get', {
            method: 'post',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(postData)
        });
    }
}